import e, { Component as t } from "react";
import n, { keyframes as o } from "styled-components";
import r from "prop-types";
import a from "react-dom";

var i = 16,
    c = function c(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    u = function u() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = c(n);
    "rem" !== o.units ? e += o.number / i : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
};

function s(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}

function l(e) {
  return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function f(e, t) {
  return (f = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function p(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e) : t;
}

var d = document.body,
    v = {
  children: r.node
},
    b = function (e) {
  function n(e) {
    var t;
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, n), (t = p(this, l(n).call(this, e))).el = document.createElement("div"), t;
  }

  var o, r, i;
  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && f(e, t);
  }(n, t), o = n, (r = [{
    key: "componentDidMount",
    value: function value() {
      d.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      d.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function value() {
      return a.createPortal(this.props.children, this.el);
    }
  }]) && s(o.prototype, r), i && s(o, i), n;
}();

b.propTypes = v;
var h = o(["from{transform:rotate(0);}to{transform:rotate(360deg);}"]),
    m = o(["from{opacity:0;}to{opacity:1;}"]),
    y = o(["from{opacity:1;}to{opacity:0;}"]),
    g = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'],
    w = g.join(","),
    E = "undefined" == typeof Element ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function O(e, t) {
  t = t || {};
  var n,
      o,
      r,
      a = [],
      i = [],
      c = new j(e.ownerDocument || e),
      u = e.querySelectorAll(w);

  for (t.includeContainer && E.call(e, w) && (u = Array.prototype.slice.apply(u)).unshift(e), n = 0; n < u.length; n++) {
    T(o = u[n], c) && (0 === (r = F(o)) ? a.push(o) : i.push({
      documentOrder: n,
      tabIndex: r,
      node: o
    }));
  }

  return i.sort(N).map(function (e) {
    return e.node;
  }).concat(a);
}

function T(e, t) {
  return !(!k(e, t) || function (e) {
    return function (e) {
      return C(e) && "radio" === e.type;
    }(e) && !function (e) {
      if (!e.name) return !0;

      var t = function (e) {
        for (var t = 0; t < e.length; t++) {
          if (e[t].checked) return e[t];
        }
      }(e.ownerDocument.querySelectorAll('input[type="radio"][name="' + e.name + '"]'));

      return !t || t === e;
    }(e);
  }(e) || F(e) < 0);
}

function k(e, t) {
  return t = t || new j(e.ownerDocument || e), !(e.disabled || function (e) {
    return C(e) && "hidden" === e.type;
  }(e) || t.isUntouchable(e));
}

O.isTabbable = function (e, t) {
  if (!e) throw new Error("No node provided");
  return !1 !== E.call(e, w) && T(e, t);
}, O.isFocusable = function (e, t) {
  if (!e) throw new Error("No node provided");
  return !1 !== E.call(e, D) && k(e, t);
};
var D = g.concat("iframe").join(",");

function F(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return isNaN(t) ? function (e) {
    return "true" === e.contentEditable;
  }(e) ? 0 : e.tabIndex : t;
}

function N(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}

function C(e) {
  return "INPUT" === e.tagName;
}

function j(e) {
  this.doc = e, this.cache = [];
}

j.prototype.hasDisplayNone = function (e, t) {
  if (e.nodeType !== Node.ELEMENT_NODE) return !1;

  var n = function (e, t) {
    for (var n = 0, o = e.length; n < o; n++) {
      if (t(e[n])) return e[n];
    }
  }(this.cache, function (t) {
    return t === e;
  });

  if (n) return n[1];
  var o = !1;
  return "none" === (t = t || this.doc.defaultView.getComputedStyle(e)).display ? o = !0 : e.parentNode && (o = this.hasDisplayNone(e.parentNode)), this.cache.push([e, o]), o;
}, j.prototype.isUntouchable = function (e) {
  if (e === this.doc.documentElement) return !1;
  var t = this.doc.defaultView.getComputedStyle(e);
  return !!this.hasDisplayNone(e, t) || "hidden" === t.visibility;
};

var x = O,
    P = function P() {
  for (var e = {}, t = 0; t < arguments.length; t++) {
    var n = arguments[t];

    for (var o in n) {
      S.call(n, o) && (e[o] = n[o]);
    }
  }

  return e;
},
    S = Object.prototype.hasOwnProperty;

var _,
    I = (_ = [], {
  activateTrap: function activateTrap(e) {
    if (_.length > 0) {
      var t = _[_.length - 1];
      t !== e && t.pause();
    }

    var n = _.indexOf(e);

    -1 === n ? _.push(e) : (_.splice(n, 1), _.push(e));
  },
  deactivateTrap: function deactivateTrap(e) {
    var t = _.indexOf(e);

    -1 !== t && _.splice(t, 1), _.length > 0 && _[_.length - 1].unpause();
  }
});

function L(e) {
  return setTimeout(e, 0);
}

var A = function A(e, t) {
  var n = document,
      o = "string" == typeof e ? n.querySelector(e) : e,
      r = P({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0
  }, t),
      a = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1
  },
      i = {
    activate: function activate(e) {
      if (a.active) return;
      h(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = n.activeElement;
      var t = e && e.onActivate ? e.onActivate : r.onActivate;
      t && t();
      return u(), i;
    },
    deactivate: c,
    pause: function pause() {
      if (a.paused || !a.active) return;
      a.paused = !0, s();
    },
    unpause: function unpause() {
      if (!a.paused || !a.active) return;
      a.paused = !1, u();
    }
  };
  return i;

  function c(e) {
    if (a.active) {
      s(), a.active = !1, a.paused = !1, I.deactivateTrap(i);
      var t = e && void 0 !== e.onDeactivate ? e.onDeactivate : r.onDeactivate;
      return t && t(), (e && void 0 !== e.returnFocus ? e.returnFocus : r.returnFocusOnDeactivate) && L(function () {
        m(a.nodeFocusedBeforeActivation);
      }), i;
    }
  }

  function u() {
    if (a.active) return I.activateTrap(i), h(), L(function () {
      m(f());
    }), n.addEventListener("focusin", d, !0), n.addEventListener("mousedown", p, !0), n.addEventListener("touchstart", p, !0), n.addEventListener("click", b, !0), n.addEventListener("keydown", v, !0), i;
  }

  function s() {
    if (a.active) return n.removeEventListener("focusin", d, !0), n.removeEventListener("mousedown", p, !0), n.removeEventListener("touchstart", p, !0), n.removeEventListener("click", b, !0), n.removeEventListener("keydown", v, !0), i;
  }

  function l(e) {
    var t = r[e],
        o = t;
    if (!t) return null;
    if ("string" == typeof t && !(o = n.querySelector(t))) throw new Error("`" + e + "` refers to no known node");
    if ("function" == typeof t && !(o = t())) throw new Error("`" + e + "` did not return a node");
    return o;
  }

  function f() {
    var e;
    if (!(e = null !== l("initialFocus") ? l("initialFocus") : o.contains(n.activeElement) ? n.activeElement : a.firstTabbableNode || l("fallbackFocus"))) throw new Error("You can't have a focus-trap without at least one focusable element");
    return e;
  }

  function p(e) {
    o.contains(e.target) || (r.clickOutsideDeactivates ? c({
      returnFocus: !x.isFocusable(e.target)
    }) : e.preventDefault());
  }

  function d(e) {
    o.contains(e.target) || e.target instanceof Document || (e.stopImmediatePropagation(), m(a.mostRecentlyFocusedNode || f()));
  }

  function v(e) {
    if (!1 !== r.escapeDeactivates && function (e) {
      return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode;
    }(e)) return e.preventDefault(), void c();
    (function (e) {
      return "Tab" === e.key || 9 === e.keyCode;
    })(e) && function (e) {
      if (h(), e.shiftKey && e.target === a.firstTabbableNode) return e.preventDefault(), void m(a.lastTabbableNode);
      if (!e.shiftKey && e.target === a.lastTabbableNode) e.preventDefault(), m(a.firstTabbableNode);
    }(e);
  }

  function b(e) {
    r.clickOutsideDeactivates || o.contains(e.target) || (e.preventDefault(), e.stopImmediatePropagation());
  }

  function h() {
    var e = x(o);
    a.firstTabbableNode = e[0] || f(), a.lastTabbableNode = e[e.length - 1] || f();
  }

  function m(e) {
    e !== n.activeElement && (e && e.focus ? (e.focus(), a.mostRecentlyFocusedNode = e, function (e) {
      return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select;
    }(e) && e.select()) : m(f()));
  }
},
    G = function () {
  function e(e, t) {
    for (var n = 0; n < t.length; n++) {
      var o = t[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }

  return function (t, n, o) {
    return n && e(t.prototype, n), o && e(t, o), t;
  };
}();

var U = function (t) {
  function n(e) {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, n);

    var t = function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));

    return t.setFocusTrapElement = function (e) {
      t.focusTrapElement = e;
    }, "undefined" != typeof document && (t.previouslyFocusedElement = document.activeElement), t;
  }

  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }(n, e.Component), G(n, [{
    key: "componentDidMount",
    value: function value() {
      var e = this.props.focusTrapOptions,
          t = {
        returnFocusOnDeactivate: !1
      };

      for (var n in e) {
        e.hasOwnProperty(n) && "returnFocusOnDeactivate" !== n && (t[n] = e[n]);
      }

      var o = a.findDOMNode(this.focusTrapElement);
      this.focusTrap = this.props._createFocusTrap(o, t), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      if (e.active && !this.props.active) {
        var t = {
          returnFocus: this.props.focusTrapOptions.returnFocusOnDeactivate || !1
        };
        this.focusTrap.deactivate(t);
      } else !e.active && this.props.active && this.focusTrap.activate();

      e.paused && !this.props.paused ? this.focusTrap.unpause() : !e.paused && this.props.paused && this.focusTrap.pause();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.focusTrap.deactivate(), !1 !== this.props.focusTrapOptions.returnFocusOnDeactivate && this.previouslyFocusedElement && this.previouslyFocusedElement.focus && this.previouslyFocusedElement.focus();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          n = e.Children.only(this.props.children);
      return e.cloneElement(n, {
        ref: function ref(e) {
          t.setFocusTrapElement(e), "function" == typeof n.ref && n.ref(e);
        }
      });
    }
  }]), n;
}();

U.defaultProps = {
  active: !0,
  paused: !1,
  focusTrapOptions: {},
  _createFocusTrap: A
};
var M = U;

function R(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function z(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function W(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? z(n, !0).forEach(function (t) {
      R(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : z(n).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var q = function q(e) {
  return {
    number: parseFloat(e),
    units: String(e).replace(/^[\d.-]+/, "")
  };
},
    B = function B() {
  for (var e = "", t = 0; t < arguments.length; ++t) {
    var n = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    "" !== e && (e += " ");
    var o = q(n);
    "rem" !== o.units ? e += o.number / 16 : e += o.number, 0 != o.number && (e += "rem");
  }

  return e;
},
    H = {
  black: "#000000",
  white: "#ffffff",
  red: "#d52b1e",
  charcoal: "#454545",
  green: "#00ac3e",
  blue: "#0088ce",
  yellow: "#ffbc3d",
  orange: "#ed7000",
  coolGray1: "#f6f6f6",
  coolGray3: "#d8dada",
  coolGray6: "#747676",
  coolGray10: "#333333",
  grayLight: "#d8dada"
},
    V = W({}, H, {}, {
  textColor: H.charcoal,
  textColorSuccess: H.white,
  textColorInfo: H.white,
  textColorWarning: H.charcoal,
  textColorError: H.white
}),
    K = {
  fontFamily: '"BrandFont-Text", Helvetica, Arial, sans-serif',
  monospace: '"SFMono-Regular", "RobotoMono-Regular", monospace',
  sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  serif: "serif",
  iconFontUrl: "https://respframework.verizon.com/fonts/verizon-icons/fonts.css",
  iconFont: "verizon-icons"
},
    Y = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
},
    J = W({}, K, {}, {
  fontColor: V.black,
  fontColorAlt: V.white,
  fontSize: B(16)
}, {
  fontWeights: Y,
  fontHeader: K.fontFamily,
  fontBody: K.sans,
  fontWeight: Y
}),
    Q = W({
  name: "Verizon Theme"
}, V, {}, J, {}, {
  primary: V.black,
  secondary: V.white,
  accent: V.red,
  background: V.white,
  backgroundColorDisabled: V.coolGray3,
  success: V.green,
  info: V.blue,
  warning: V.yellow,
  error: V.orange,
  disabled: V.coolGray3,
  textColorSuccess: V.white,
  textColorInfo: V.white,
  textColorWarning: V.black,
  textColorError: V.black,
  textColorDisabled: V.white,
  borderWidth: B(1),
  borderStyle: "solid",
  borderColor: V.coolGray3,
  border: "".concat(B(1), " solid ").concat(V.coolGray3),
  borderColorDisabled: V.coolGray3,
  linkColor: V.black,
  linkColorHover: V.blue,
  linkColorActive: V.blue,
  linkDecoration: "underline",
  transitionDuration: "0.2s",
  hrPrimary: "".concat(B(4), " solid ").concat(V.charcoal),
  hrSecondary: "".concat(B(1), " solid ").concat(V.charcoal),
  hrTertiary: "".concat(B(1), " solid ").concat(V.coolGray3)
}),
    X = {
  active: r.bool,
  fullscreen: r.bool,
  className: r.string,
  theme: r.object
},
    Z = {
  active: !1,
  fullscreen: !1,
  className: null,
  theme: Q
},
    $ = n.div.withConfig({
  displayName: "Loader__StyledOverlay",
  componentId: "sc-1ojqk4s-0"
})(["background-color:", ";top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:999;position:", ";display:", ";animation:", " 0.15s linear;opacity:0.8;"], Q.white, function (e) {
  return e.fullscreen ? "fixed" : "absolute";
}, function (e) {
  return e.active ? "block" : "none";
}, function (e) {
  return e.active ? m : y;
}),
    ee = n.div.withConfig({
  displayName: "Loader__StyledLoader",
  componentId: "sc-1ojqk4s-1"
})(["display:", ";animation:", " 0.15s linear;&::after{content:'';position:", ";top:0;bottom:0;left:0;right:0;margin:auto;width:", ";height:", ";display:block;z-index:3;border:", " solid ", ";border-top-color:transparent;border-radius:50%;animation:", " 0.5s infinite linear;}"], function (e) {
  return e.active ? "block" : "none";
}, function (e) {
  return e.active ? m : y;
}, function (e) {
  return e.fullscreen ? "fixed" : "absolute";
}, u(40), u(40), u(4), function (e) {
  return e.primaryColor;
}, h),
    te = function te(t) {
  var n = t.active,
      o = t.fullscreen,
      r = t.className,
      a = t.theme;
  return n ? o ? e.createElement(b, {
    "aria-label": "loader container"
  }, e.createElement(M, {
    focusTrapOptions: {
      escapeDeactivates: !1
    }
  }, e.createElement($, {
    active: n,
    "aria-label": "loader overlay",
    className: r
  }, e.createElement(ee, {
    tabIndex: 0,
    active: n,
    "aria-label": "loader animation",
    theme: a
  })))) : e.createElement(M, {
    focusTrapOptions: {
      escapeDeactivates: !1
    }
  }, e.createElement($, {
    active: n,
    "aria-label": "loader overlay",
    className: r
  }, e.createElement(ee, {
    tabIndex: 0,
    active: n,
    "aria-label": "loader animation"
  }))) : null;
};

te.propTypes = X, te.defaultProps = Z;
export { m as FadeInAnimation, y as FadeOutAnimation, te as Loader, b as LoaderPortal, h as LoadingAnimation };